export const AuthDocumentacioExtra = ({ auth, handleChange, error }) => {

  return (<>
    <div className="row">
      <div className="col col-12 ">
        <h4>
          Documentació secretaria
        </h4>
        <p>

          Tot l'alumnat de <b>Formació Professional i Batxillerat de nou ingrés</b> al centre ha de portar a secretaria entre l'1 i el 19 de setembre

          <ul>
            <li>l'original del DNI.</li>
            <li>el resguard del títol pel qual s'accedeix als estudis matriculats.</li>
          </ul>

          En cas de no aportar aquesta documentació, l'estudiant pot ser donat de baixa.

          <br />
          <br />

          <label>
            <input type="checkbox" id="authDocumentacioExtra" name="authDocumentacioExtra" value={auth} checked={auth === "1" ? true : false} onChange={(t) => { handleChange(t.target.value) }} required />
            Em comprometo a aportar aquesta documentació en el període estipulat
          </label>

          <span id="auhtMaterial_ERROR" className="a-Form-error">{error}</span>

        </p>


      </div>
    </div>

    <br />

  </>)
}
